import {useLayoutBaseRepository, useLayoutPullRequestId} from '@github-ui/pull-requests/pull-request-store-selectors'

/**
 * Builds the `modelsUrl` that surfaces the Copilot "Fix with Copilot" model picker in the
 * Files Changed view.
 *
 * The URL points at the PR-aware coding-agent models proxy on the **base** repository — for
 * fork PRs the endpoint lives on the base repo, not the head repo. `pull_id` is the numeric
 * database id so the proxy can compute the PR's current model.
 */
export function useFilesChangedModelPickerModelsUrl(): string {
  const pullRequestId = useLayoutPullRequestId()
  const baseRepository = useLayoutBaseRepository()

  return `/${baseRepository.ownerLogin}/${baseRepository.name}/copilot/coding_agent/models?pull_id=${pullRequestId}`
}
